{
  "defaults": {
    "voiceNavApiBase": "https://medicallink-france.fr",
    "widgetPublicUrl": "https://medicallink-online.fr",
    "widgetBundlePath": "/voice-nav-widget.js"
  },
  "voiceNav": {
    "chatCommand": "/chat/command",
    "sportsCertificateAccessibleLocations": "/chat/sports-certificate/accessible-locations",
    "sportsCertificateConvertPdf": "/chat/sports-certificate/convert-pdf",
    "sportsCertificatePreview": "/chat/sports-certificate/preview",
    "sportsCertificateMail": "/chat/sports-certificate/mail",
    "ttsSynthesize": "/tts/synthesize",
    "ttsGtts": "/tts/gtts",
    "versionInfo": "/version",
    "voiceNormalize": "/api/voice/normalize",
    "webSocketTranscribe": "/ws/transcribe",
    "transcribeVoice": "/transcribe/voice",
    "sessionContext": "/session/context",
    "sessionActivePatient": "/session/active-patient",
    "sessionPendingUiReplay": "/session/pending-ui/replay",
    "sessionChatHistory": "/session/chat-history",
    "sessionWorkflowAction": "/session/workflow-action",
    "logout": "/logout"
  },
  "medicalLink": {
    "origin": "https://medicallink-online.fr",
    "appPortalUserSegment": "medecin",
    "security": {
      "attachmentDownloadAllowedHostSuffixes": [".amazonaws.com"],
      "attachmentDownloadAllowedHosts": ["medicallink-online.fr"]
    },
    "rest": {
      "doctorGetUnreadMessages": "/api/doctor/get-unread-messages",
      "patientGetLastMessages": "/api/patient/get-last-messages",
      "recentOrdBioDetail": "/api/recent_ord_bio_detail",
      "vidalRenewalAi": "/api/vidal-renewal-ai",
      "patientDossierRecent": "/api/patient/dossier/recent",
      "patientDossierRecentNestedTemplate": "/api/patient/{patientId}/dossier/recent",
      "recentOrdonnanceDetail": "/api/recent_ordonnance_detail",
      "doctorTimeToWork": "/api/doctor/time-to-work",
      "doctorAddReminderTask": "/api/doctor/add-reminder-task",
      "accessibleLocationsList": "/api/accessible/locations/list",
      "sendEmail": "/api/send-email",
      "searchPatient": "/api/search-patient",
      "patientList": "/api/patient/list",
      "discussionInitiate": "/api/discussion/initiate",
      "usersAutofill": "/api/users-autofill",
      "sportsCertificateFields": "/api/sports-certificate/fields",
      "sportsCertificateCreate": "/api/patient/sports-certificate"
    },
    "app": {
      "messagingInbox": "/medecin/{userId}/boite-de-reception",
      "navigationMenu": "/medecin/{userId}/{menuRoute}",
      "patientDossier": "/medecin/{userId}/patient/dossier/{patientId}"
    },
    "sportsCertificate": {
      "commentsFieldId": 10
    }
  },
  "external": {
    "microsoftOfficeEmbedViewerBaseUrl": "https://view.officeapps.live.com/op/embed.aspx"
  }
}
